export const createProfileSlice = (set) => ({
    profile: null,
    setProfile: (profile) => set({ profile }),
    clearProfile: () => set({ profile: null }),
});
//# sourceMappingURL=profileSlice.js.map